// src/api/permissionApi.js
import appInstance from "@/services/applicationService/appinstance";
import instance from "@/services/axiosConfig";

// ─── Permission CRUD ──────────────────────────────────────────────────────────

export const fetchAllPermissions = ({ role, search, page = 1, limit = 20 } = {}) =>
  instance.get("/permissions", { params: { role, search, page, limit } })
    .then((r) => r);

export const fetchPermissionByUserId = (userId) =>
  instance.get(`/permissions/${userId}`).then((r) => r);

export const createUserWithPermission = (payload) =>
  instance.post("/permissions/user", payload).then((r) => r);

export const saveUserPermissions = (userId, payload) =>
  instance.put(`/permissions/${userId}`, payload).then((r) => r);

export const toggleMenuPermission = (userId, menuId, enabled) =>
  instance.patch(`/permissions/${userId}/menu`, { menuId, enabled })
    .then((r) => r);

export const updateMenuCrud = (userId, body) =>
  instance.patch(`/permissions/${userId}/menu/crud`, body).then((r) => r);

export const updateResourceCrud = (userId, body) =>
  instance
    .patch(`/permissions/${userId}/menu/resource`, body)
    .then((r) => r);

export const deletePermission = (userId) =>
  instance.delete(`/permissions/${userId}`).then((r) => r);

export const checkPermission = (userId, { menuId, resource_type, resource_id, action }) =>
  instance
    .get(`/permissions/check/${userId}`, {
      params: { menuId, resource_type, resource_id, action },
    })
    .then((r) => r);

// ─── Resources (charts + modules) fetched client-side from SeaFlash ──────────
export const fetchCharts = () =>
  instance.get("/superadmin/getallcharts").then((r) => r?.data || r || []);

export const fetchmodulegroup = () =>
  instance.get("/superadminsettings/listmodulegroup").then((r) => r?.data || r || []);

export const fetchbenchmarks = () =>
  instance.get("/ships/benchmark").then((r) => r || r || []);

export const fetchusers = () =>
  instance.get("/user/viewusers").then((r) => r || r || []);

export const fetchevents = () =>
  instance.get("/superadmin/allevents").then((r) => r || r || []);

export const manageShips = () =>
  appInstance.get("/ships").then((r) => r || r || []);


export const fetchModules = () =>
  instance.get("/create/viewmodule").then((r) => r?.data || r || []);

export const fetchResources = async () => {
  const [chartsResult, modulesResult] = await Promise.allSettled([
    fetchCharts(),
    fetchModules(),
  ]);
  return {
    charts: chartsResult.status === "fulfilled" ? chartsResult.value : [],
    modules: modulesResult.status === "fulfilled" ? modulesResult.value : [],
  };
};